import styled from 'styled-components'

export const PageRangeBase = styled.p`
  font-size: 12px;
`
